import React, { Component } from 'react'
import config from '../../resource/config.js'

const submitApi = config.apiBaseUrl + 'apbe/requestsubmitter'

class submitModal extends Component {
    constructor(props) {
        super(props)
        this.finalSubmit = this.finalSubmit.bind(this)
        this.state = { data: 'false', cognitoId: '', reqId: '', isLoading: true }
        this.modalId = `${this.props.triggerId.replace('Trigger', '')}Container`
    }

    finalSubmit() {
        console.log("Data values in SubmitModal" + this.props.PassDataItems.COGNITO_ID)
        var requestParams = {
            cognitoId: this.props.PassDataItems.COGNITO_ID,
            reqid: this.props.PassDataItems.REQUEST_ID,
            orgid: this.props.PassDataItems.ORG_ID,
            updatetype: 'submission'
        }
        fetch(submitApi, {
            method: 'POST',
            dataType: 'jsonp',
            headers: this.props.apiAuthHeaders,
            body: JSON.stringify(requestParams)
        }).then((response) => {
            return response.json()
        }).then((responseData) => {
            console.log("responseData statusPage", responseData)
            if (responseData === "request to trigger bsPersonSls submitted successfully") {
                window.location.reload()
                this.setState({ isLoading: false })
            }
        }).catch(function (err) {
            console.log(err)
        })

    }

    componentDidMount() {
        const triggerElement = document.getElementById(this.props.triggerId)
        if (triggerElement) {
            window.cb.apricot.CBModal.init({
                elem: triggerElement,
                targetElem: this.modalId,
            })
        }
    }

    render() {
        return (
            <div className="submitModal">
                <div id={this.modalId} className="cb-modal" aria-hidden="true">
                    <div className="cb-modal-overlay" tabIndex="-1" data-cb-modal-close>
                        <div className="cb-modal-container" role="dialog" aria-modal="true"
                             aria-labelledby={`${this.modalId}Title`}>
                            <div className="cb-modal-header cb-modal-has-close">
                                <h2 className="cb-modal-title" id={`${this.modalId}Title`}>Confirm Submission</h2>
                                <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale cb-btn-close"
                                        aria-describedby={`${this.modalId}Title`} data-cb-modal-close>
                                    <span className="cb-glyph cb-x-mark" aria-hidden="true"></span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </div>
                            <div className="cb-modal-content">
                                <p>Are you sure you want to submit your file?</p>
                                <p>Click <strong>Yes</strong> to submit your file. Your data will then be sent to the AP
                                    Registration &amp; Ordering system. Click <strong>No</strong> to return to your
                                    request.</p>
                            </div>
                            <div className="cb-modal-footer">
                                <div className="cb-btn-row">
                                    <button type="button" className="btn btn-naked btn-sm" data-cb-modal-close>NO
                                    </button>
                                    <button type="button" className="btn btn-primary btn-sm cb-margin-left-16"
                                            data-cb-modal-close
                                            onClick={this.finalSubmit}>YES
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default submitModal
